import { defineStore } from 'pinia'
import { sortBy } from 'lodash'
import Station from '@/models/Station'
import Area from '@/models/Area'
import { getSpMode } from '@/lib/sp'

export const TOP_VIEW_TYPES = {
  GRAPHICAL: 'graphical',
  SUMMARY: 'summary',
} as const

export type TopViewType = (typeof TOP_VIEW_TYPES)[keyof typeof TOP_VIEW_TYPES]

export const useGlobalStore = defineStore('global', {
  state: () => ({
    isIchinomiya: process.env.VUE_APP_TARGET === 'ichinomiya',
    isAdachi: process.env.VUE_APP_TARGET === 'adachi',
    systemName: '川崎市防災気象情報',
    systemViewmode: 0,
    logo: '/assets/images/logo.svg',
    copyright: '©2022 ANEOS Corporation.  All Rights Reserved.',
    updatedAt: '2022-01-01',
    title: '川崎市防災気象情報',
    subTitle: '',
    isSP: getSpMode(),
    top: {
      viewType: TOP_VIEW_TYPES.GRAPHICAL as TopViewType,
      showPopup: false,
    },
    currentArea: undefined as Area | undefined,
    currentStation: undefined as Station | undefined,
    showLeftMenu: true,
    showUdcSelect: false,
    autoUpdateEnable: true,
    isShowPopup: false,
  }),

  getters: {
    topIsGraphical: state => {
      return state.top.viewType === TOP_VIEW_TYPES.GRAPHICAL
    },

    topIsSummery: state => {
      return state.top.viewType === TOP_VIEW_TYPES.SUMMARY
    },

    waterThreshold: state => {
      const station = state.currentStation

      return sortBy(station?.threshold?.filter(t => t.type === 'water') || [], 'comparison').reverse()
    },

    rainThreshold: state => {
      const station = state.currentStation

      return station?.threshold?.filter(t => t.type === 'rain') || []
    },
  },

  actions: {
    startAutoUpdate() {
      this.autoUpdateEnable = true
    },
    stopAutoUpdate() {
      this.autoUpdateEnable = false
    },
    setCurrentStation(station?: Station) {
      this.currentStation = station
    },
    setCurrentArea(area?: Area) {
      this.currentArea = area
    },
  },
})
